import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
import phoneSample from "assets/img/phoneSample.png";
import projectsStyle from "assets/jss/trip-kit/views/sectionsSections/projectsStyle.js";
import apple from "assets/img/apple.png";
import android from "assets/img/play-market.png";
import youtubeImg from "assets/img/youtube-logo.png";

//언어 셋팅
import { withTranslation } from "react-i18next";
import i18n from "config/lang/i18n.js";

const useStyles = makeStyles(projectsStyle);

const SectionAppDown = (props) =>{

  const classes = useStyles();
  /*
  const isPc = useMediaQuery({
    query : "(min-width: 768px)"
  })
  const isMobile = useMediaQuery({
    query : "(max-width: 767px)"
  })
  */

  const ready = () =>{console.log(2);
    alert("Coming soon");
  }
  return (
    <div className={classes.projects}>
      <div className={classes.container}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card
              raised
              background
              style={{ backgroundImage: `url(${phoneSample})`,backgroundColor:"#263343",marginTop:0}}
            >
              <CardBody background>
                <h3 className={classes.cardTitleWhite}>
                  Download our App
                </h3>
                <p className={classes.cardDescription} style={{fontWeight:"400",padding:20}}>
                {i18n.t('headDescription')}
                </p>
                <a href="https://play.google.com/store/apps/details?id=com.tripcheckiner.travel"  target='_blank' rel='nofollow noopener noreferrer'>
                <Button color="github" style={{textTransform:"none",padding:15,paddingTop:7,paddingBottom:7,borderRadius:"10px"}}>
                  <img style={{width:"20px",marginRight:"7px",verticalAlign:"bottom"}} src={android} alt="google play" /><span style={{marginLeft:10}}>Download on<br />Google Play</span>
                </Button>
                </a>
               {/* iphone
                <a href="https://itunes.apple.com/app/id1574288365?mt=8"  target='_blank' rel='nofollow noopener noreferrer'>
                <Button color="github"  style={{textTransform:"none",padding:15,paddingTop:7,paddingBottom:7,borderRadius:"10px",marginLeft:10}}>
                  <img style={{width:"20px",marginRight:"7px",verticalAlign:"bottom"}} src={apple} alt="app store" /><span style={{marginLeft:10}}>Download on<br />App Store</span>
                </Button>
                </a>
                */}
                <a href="https://www.youtube.com/@tripcheckiner"  target='_blank' rel='nofollow noopener noreferrer'>
                <Button color="github"  style={{textTransform:"none",padding:15,paddingTop:0,paddingBottom:0,borderRadius:"10px",marginLeft:10}}>
                  <img style={{width:"50px",marginRight:"7px",verticalAlign:"bottom"}} src={youtubeImg} alt="Youtube" /><span style={{marginLeft:0}}>Youtube</span>
                </Button>
                </a>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}

export default withTranslation()(SectionAppDown);